import { z } from 'zod'

export type TUserAgentInfo = {
	userAgent?: string
	browser?: string
	browserVersion?: string
	platform?: string
	deviceType?: string
	isStandalone?: boolean
}

export const UserAgentInfoSchema = z.object({
	userAgent: z.string().optional(),
	browser: z.string().optional(),
	browserVersion: z.string().optional(),
	platform: z.string().optional(),
	deviceType: z.string().optional(),
	isStandalone: z.boolean().optional(),
})

// Function to check if the app is running in standalone mode (PWA)
export function isStandalone() {
	if (typeof window === 'undefined') return false
	return (
		window.matchMedia('(display-mode: standalone)').matches ||
		(window.navigator as any).standalone ||
		document.referrer.includes('android-app://')
	)
}

// New utility file to parse user agent info
export function parseUserAgent(userAgent: string): TUserAgentInfo {
	// Basic parsing - you might want to use a library like "ua-parser-js" for more robust parsing
	const browser = userAgent.match(
		/(chrome|firefox|safari|edge|opera)\/?\s*(\d+)/i,
	)
	const platform = userAgent.match(/(windows|mac|linux|android|ios)/i)
	const mobile = /mobile|android|ios|iphone|ipad/i.test(userAgent)

	return {
		userAgent,
		browser: browser?.[1]?.toLowerCase() ?? 'unknown',
		browserVersion: browser?.[2] ?? 'unknown',
		platform: platform?.[1]?.toLowerCase() ?? 'unknown',
		deviceType: mobile ? 'mobile' : 'desktop',
		isStandalone: isStandalone(),
	}
}
